var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorLaboratory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.385,3.532h4.103v13.521l-12.02,16.806c-1.379,1.928,0,4.608,2.37,4.608h26.325c2.37,0,3.748-2.68,2.37-4.608l-12.02-16.806V3.532h4.103"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31.048,26.191H10.952l-5.484,7.668c-1.379,1.928,0,4.608,2.37,4.608h26.325c2.37,0,3.748-2.68,2.37-4.608l-5.484-7.668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorLaboratory);
export default __webpack_public_path__ + "static/media/indoor-laboratory.b2d2876ca8277eb29602004b961b06bd.svg";
export { ForwardRef as ReactComponent };